import { render, staticRenderFns } from "./DashboardFasttrack.vue?vue&type=template&id=2fec2f98&scoped=true&"
import script from "./DashboardFasttrack.vue?vue&type=script&lang=js&"
export * from "./DashboardFasttrack.vue?vue&type=script&lang=js&"
import style0 from "./DashboardFasttrack.vue?vue&type=style&index=0&id=2fec2f98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fec2f98",
  null
  
)

export default component.exports